import React, { Fragment } from 'react';

const BannersUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row last">
        <div className="left">
          <h1 className="h1 page-title">
            Banners are blocks of information that can be combined between them and other components.
          </h1>
        </div>
        <div className="right">
          <p>Each banner presented in the library is unique and has a context where it should be used. They are split into different categories with designated ends: Benefits banners for showing benefits; Card banners for content about rates, awards or plans; Banners for testimonials, news, media, etc.</p>
        </div>
      </article>
    </section>
    <section className="bg-grey flex-grow-1 with-padding">
      <article className="flex-row flex-justify-end">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Elements</h2>
          <p>Each version of the banners presented is composed of different elements in a specific order. On the documentation, you can see what elements compose each banner and the differences between each breakpoint.</p>
          <h2 className="h2 page-subtitle">Colours</h2>
          <p>The banners can have several colour combinations, that have been thought and documented. It is up to the designer to make the decision of what of the colour combinations fit into the page where the banner is being used in. </p>
          <h2 className="h2 page-subtitle">Composition</h2>
          <p>Different banners can be used together depending on the needs of each page. To get to know all the possible combinations, please consult the documentation where you can find the rules for that.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default BannersUsage;


// WEBPACK FOOTER //
// ./src/containers/components/Banner/BannersUsage.js